/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/TipsOption',{
    Enable: 1,
    Disable: 0
});
